// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export namespace CalendarTypes {
  export interface DateDetail {
    date: Date;
  }

  export interface DateDetailNullable {
    date: Date | null;
  }
}
